import { YtjYrityshaunTulos } from '@lemon/core-firebase/model/ytj-api'

export interface YtjHakutulosNakymassa {
  yritys: YtjYrityshaunTulos
  nimiEnnenOsumaa: string
  nimenOsuma: string
  nimiOsumanJalkeen: string
  osoiteteksti: string | null
}

export const YTJ_HAKUSANAN_VAHIMMAISPITUUS = 3

export function onkoYtjOsoiteMukana(yritys: YtjYrityshaunTulos): boolean {
  return !!yritys.katuosoite || !!yritys.postinro || !!yritys.postitmp
}

export function onkoYtjHakusanaRiittava(hakusana: string, onkoYtunnus: boolean): boolean {
  return onkoYtunnus || hakusana.length >= YTJ_HAKUSANAN_VAHIMMAISPITUUS
}

export function annaYtjHakutulosNakymassa(yritys: YtjYrityshaunTulos, hakusana: string): YtjHakutulosNakymassa {
  const osoiteteksti = onkoYtjOsoiteMukana(yritys) ? `${yritys.katuosoite ?? ''}, ${yritys.postinro ?? ''} ${yritys.postitmp ?? ''}`.trim() : null
  const pieniHakusana = hakusana.trim().toLowerCase()
  const osumanAlku = pieniHakusana ? yritys.nimi.toLowerCase().indexOf(pieniHakusana) : -1
  if (osumanAlku < 0) {
    return { yritys, nimiEnnenOsumaa: yritys.nimi, nimenOsuma: '', nimiOsumanJalkeen: '', osoiteteksti }
  }
  const osumanLoppu = osumanAlku + pieniHakusana.length
  return {
    yritys,
    nimiEnnenOsumaa: yritys.nimi.slice(0, osumanAlku),
    nimenOsuma: yritys.nimi.slice(osumanAlku, osumanLoppu),
    nimiOsumanJalkeen: yritys.nimi.slice(osumanLoppu),
    osoiteteksti,
  }
}
